module.exports = __webpack_public_path__ + "static/img/signSucess.b84c19af.png";